/**
 * IDs de cooperativas con pantalla Difundir → Noticia.
 * Configurar en `.env` del frontend:
 *   REACT_APP_NOTICIA_ENABLED_COOPS=id1,id2,id3
 * Separados por coma, sin espacios obligatorios (se recortan).
 * Si no definís la variable, por defecto quedan Porteña (bot-coop), Henderson (bot-henderson) y Carabelas (bot-carabelas).
 */
const DEFAULT_ENABLED_COOPS = [
  "6722a6f4ce3fc071ca22ed14",
  "6839b2782309582992f346b2",
  "6742343bd7e810d622f99424",
];

const parseEnabledCoops = () => {
  const raw = process.env.REACT_APP_NOTICIA_ENABLED_COOPS;
  if (!raw || !String(raw).trim()) return [...DEFAULT_ENABLED_COOPS];

  return String(raw)
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
};

export const getNoticiaEnabledCoops = () => parseEnabledCoops();

export const isNoticiaEnabledForCoop = (coopId) => {
  if (!coopId) return false;
  const enabled = parseEnabledCoops();
  return enabled.includes(String(coopId));
};

/** @deprecated Usar getNoticiaEnabledCoops; se mantiene por compatibilidad. */
export const COOP_PORTENA_NOTICIA_ID = DEFAULT_ENABLED_COOPS[0];
